import {
  Button,
  ButtonGroup,
  Checkbox,
  Group,
  IconCheckmark,
  IconCheckmarkCircle,
  IconMinusCircle,
  Modal,
  Table,
  TextBox,
} from "@veneer/core";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";
import { apiPost } from "../../../../services/service";
import {
  POST_ADD_OR_REMOVE,
  POST_CHANGE_SELECTION,
} from "../../../../services";
import { toast } from "react-toastify";
import Exporttoexcel from "../../case-homepage/cases/exporttoexcel";
import { HpLogo } from "../../shared-components/hp-logo/hp-logo";
import Loader from "../../shared-components/loader/loader";

export const AccountUser = (props: any) => {
  const { t } = useTranslation();
  const [modalContent, setModalContent] = useState("");
  const [progress, setProgress] = useState(false);
  const [flagValue, setFlagValue] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState();
  const [formattedData, setFormattedData] = useState();
  const [exportdata, setExportData] = useState([]);
  const [accountUsers, setAccountUsers] = useState<any>(props.tabledata);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [selectedRoles, setSelectedRoles] = useState<{
    [key: string]: boolean;
  }>({});
  const [checkedValues, setCheckedValues] = useState<any>([]);
  const [open, setOpen] = useState(false);

  const tableData = props.tabledata;
  
  const changeUserRole = (e: any, item: any) => {
    const checked = e.target.checked;
    setProgress(true);
    setIsLoading(true);
    setSelectedRoles((prev) => ({
      ...prev,
      [e.target.name]: !prev[e.target.name],
    }));
    changeUserType(item?.UserID, checked);
  };

  const changeUserType = async (contactguid: string, states: boolean) => {
    try {
      let payload = {
        contactguid: contactguid,
        checkboxinput: states,
        
        
      };
      const res = await apiPost(POST_ADD_OR_REMOVE, payload);
      if (res.data) {
        setCheckedValues([]);
        props.fetchdata();
        toast.success(t('HPI.Success.UserRoleHasbeenChanged',{defaultValue:'User Role has been Changed'}));
        setProgress(false);
      } else {
        toast.error(res.Message);
        setProgress(false);
      }
    } catch (error) {
      console.log(error);
      setProgress(false);
    }
  };

  const addUserRoleCheckbox = (item: any, index: number) => {
    const Checked = item?.Role === "Administrators" ? true : false;
    return (
      <>
        <Checkbox
          checked={Checked}
          onChange={(e: any) => changeUserRole(e, item)}
        />
      </>
    );
  };

  const showUser = (value: any) => {
    if (value === "true") {
      return <IconCheckmarkCircle size={20} filled color="green" />;
    } else {
      return <IconMinusCircle size={20} filled color="red" />;
    }
  };

  useEffect(() => {
    //const sortedUsers = Array.isArray(tableData) ?tableData.sort((a:any, b:any) => a.UserName.localeCompare(b.UserName)): undefined
    const formattedData: any = tableData?.map((item: any, index: number) => {
      return {
        Index: index + 1,
        Select: addCustomeCheckBox(item),
        UserName: item.UserName,
        CompanyName: item.CompanyName,
        Phone: item.Phone,
        Country: item.Country,
        Email: item.Email,
        Role: addUserRoleCheckbox(item, index),
        isactive: showUser(item.isactive),
      };
    });
    let formateddataforXL: any = tableData?.map((item: any, index: number) => {
      return {
        "User name": item.UserName,
        "Site name": item.CompanyName,
        Phone: item.Phone,
        Country: item.Country,
        Email: item.Email,
        Active: item?.isactive === "true" ? "Yes" : "No",
        Administrator: item?.Role === "Administrators" ? "Yes" : "No",
      };
    });
    
    setExportData(formateddataforXL);
    setFormattedData(formattedData);
    setAccountUsers(formattedData);
    setIsLoading(false);
  }, [tableData || selectedRoles]);

  const searchContact = (query: string, contacts: any) => {
    return contacts.filter((contact: any) =>
      contact.UserName.toLowerCase().includes(query.toLowerCase())
    );
  };

  const searchAccount = (e: any) => {
    setSearchValue(e);
    let filteropt = searchContact(e, formattedData);
    setAccountUsers(filteropt);
  };

  const columns = [
    {
      id: "Select",
      label: t("HPI.PP.Select", { defaultValue: "Select" }),
    },
    {
      id: "UserName",
      label: t("HPI.PP.UserName", { defaultValue: "User name" }),
    },
    {
      id: "CompanyName",
      label: t("HPI.PP.Accountname", { defaultValue: "Site name" }),
    },
    {
      id: "Phone",
      label: t("HPI.PP.phone", { defaultValue: "Phone" }),
    },
    {
      id: "Country",
      label: t("HPI.Country", { defaultValue: "Country" }),
    },
    {
      id: "Email",
      label: t("HPI.PP.email", { defaultValue: "Email" }),
    },
    {
      id: "isactive",
      label: t("HPI.PP.active", { defaultValue: "Active" }),
    },
    {
      id: "Role",
      label: t("HPI.ProfilePage.Role", { defaultValue: "Administrator" }),
    },
  ];
  const unchecked = () => {
    setCheckedValues({})   
  };
  const handleCheckboxChange = (event: any) => {
    const { name, checked } = event.target;
    setCheckedValues((prevValues: any) => {
      if (checked) {
        return [...prevValues, name];
      } else {
        return prevValues.filter((value: any) => value !== name);
      }
    });
  };

  const addCustomeCheckBox = (item: any) => {
    return (
      <Checkbox
        onChange={handleCheckboxChange}
        name={item.UserID}
        className="checkbox-custom"
        value={item}
      />
    );
  };
  const userActivate = async () => {
    if (checkedValues.length <= 0) {
      toast.error(t('HPI.General.js.SelectRow',{defaultValue:'Please select at least one row to perform this operation.'}));
      return false;
    }
    setFlagValue(true);
    setModalContent(
      `<span>${checkedValues.length} ${t('HPI.ProfilePage.js.ConfirmActivation',{defaultValue:'user will be activated. Please confirm.'})}</span>`
    );
    setOpen(true);
  };

  const changeURLRole = async (flag: boolean) => {
    try {
      setOpen(false);
      let payload = {
        selectedguids: checkedValues.join(";"),
        flag: flag,
        
        
      };

      let res = await apiPost(POST_CHANGE_SELECTION, payload);
      if (res.data) {
        setModalContent("");
        setFlagValue(false);
        props.fetchdata();
        toast.success(res.data.successmessage);
      } else {
        toast.error(res.Message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const checkConfirm = () => {
    changeURLRole(flagValue);
  };
  const closeModal = () => {
    setModalContent("");
    setFlagValue(false);
    setOpen(false);
  };

  const userDectivate = async () => {
    if (checkedValues.length <= 0) {
      toast.error(t('HPI.General.js.SelectRow',{defaultValue:'Please select at least one row to perform this operation.'}));
      return false;
    }
    setOpen(true);
    setFlagValue(false);
    setModalContent(
      `<span>${checkedValues.length} ${t('HPI.ProfilePage.js.DeactivateUser',{defaultValue:'user will be deactivated.'})}</span> <br/><strong class="error">${t('HPI.ProfilePage.js.ConfirmDeactivation',{defaultValue:'Please confirm that you would like to deactivate this user(s). Once deactivated, the user will no longer have access to MyHPSupport portal.'})}</strong>`
    );
  };
  return (
    <div className="account-user">
      {progress && (
        <div className="loader-overlay">
          <div className="loader-css">
            <Loader />
          </div>
        </div>
      )}
      <div className="header-sec">
        <h5>{t('HPI.ProfilePage.AccountUserTitle',{defaultValue:'Account User'})}</h5>
        <p>
          {t("HPI.Profilepage.accountuser.usergrid", {
            defaultValue: "Added user displayed in the below grid.",
          })}
        </p>
      </div>
      <Row>
        <Col col={12} md={4}>
          <TextBox
            value={searchValue}
            onChange={(e) => searchAccount(e)}
            //placeholder="Search by User Name"
          />
        </Col>

        <Col col={12} md={6}>
          <ButtonGroup>
            <Button onClick={userActivate}>
              <IconCheckmark color="#fff" />{" "}
              {t("HPI.ContractWarranties.Activateuser", {
                defaultValue: "Activate User",
              })}
            </Button>
            <Button onClick={userDectivate}>
              <IconMinusCircle color="#fff" />{" "}
              {t("HPI.ContractWarranties.Deactivateuser", {
                defaultValue: "Deactivate User",
              })}
            </Button>
          </ButtonGroup>
        </Col>
        <Col col={12} md={2}>
          <Exporttoexcel
            //header={columns.map((column) => column.id)}
            fileName="users"
            rows={exportdata}
          ></Exporttoexcel>
        </Col>
      </Row>

      <Row>
        <Col className="mt-5">
          <Table
            columns={columns}
            loading={isLoading}
            data={accountUsers ? accountUsers : ""}
          />
        </Col>
      </Row>

      <Modal
        align="start"
        id="modal-id"
        show={open}
        onClose={() => setOpen(false)}
        title="Title"
        closeButton
        header={
          <div className="row">
            <Col>
              <HpLogo />
            </Col>
            <Col>
              <h3>{t('HPI.EditCase.ModalAlert.Alert',{defaultValue:'Alert'})}</h3>
            </Col>
          </div>
        }
        footer={
          <Group>
            <Button onClick={checkConfirm}>{t('HPI.Ok',{defaultValue:'Ok'})}</Button>
            <Button onClick={closeModal} appearance="secondary">
              {t('HPI.Cancel',{defaultValue:'Cancel'})}
            </Button>
          </Group>
        }
      >
        <p dangerouslySetInnerHTML={{ __html: modalContent }} />
      </Modal>
    </div>
  );
};
